// import {useState,useEffect} from 'react'
// import IndependentResearcherHome from './IndependentResearcherHome'
// import { useNavigate, useSearchParams } from 'react-router-dom';
// import ResearcherNavbar from './ResearcherNavbar';
// import MarketPlaceFeedNavbar from '../MarketPlaceFeedNavbar';
// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const IndependentResearcherLayout = () => {
// const navigate = useNavigate();
// const [profileExists, setProfileExists] = useState(false);
// const [loading, setLoading] = useState(true);

// useEffect(() => {
//   const fetchProfile = async () => {
//     try {
//       const res = await fetch(`${BASE_URL}/marketplace/researcher/profile`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//           "Content-Type": "application/json",
//           "x-api-key": process.env.REACT_APP_X_API_KEY,
//         },
//       });

//       const data = await res.json();
//       // console.log("The my data is:",data)
//       if (!res.ok || !data || data.has_profile === false) {
//         navigate("/marketplace/independent_researcher/profile");
//         setProfileExists(false);
//       } else {
//         setProfileExists(true);
//       }
//     } catch (err) {
//       console.error(err);
//       navigate("/marketplace/independent_researcher/profile");
//       setProfileExists(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchProfile();
// }, [navigate]);

// // 🔥 UI Rendering
// if (loading) {
//   return (
//     <div className="flex items-center justify-center h-screen bg-gray-50">
//       <div className="flex flex-col items-center gap-4">
//         <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
//         <p className="text-gray-600 text-sm">Loading your profile...</p>
//       </div>
//     </div>
//   );
// }

// return (
  // <>
  //   {profileExists && (
//       <>
//         <MarketPlaceFeedNavbar />
//         <IndependentResearcherHome />
//       </>
//     )}
//   </>
// );}

// export default IndependentResearcherLayout




import { useEffect, useState } from "react";
import Header from "../../../components/marketplace/Header";
import ResearchQuestions from "./onboarding/ResearchQuestions";
import bgImage from "../../../assets/backgroundvector.jpg";
import AdminImg from "../../../assets/admin.png";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const IndependentResearcherLayout = () => {
  const [profile, setProfile] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        const data = await res.json();
        if (res.ok) {
          setProfile(data.data);
        } else {
          console.error("Profile fetch failed", data);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingProfile(false);
      }
    };

    fetchProfile();
  }, []);

  if (loadingProfile) {
    return (
      <div className="min-h-screen bg-[#F9F7F4] font-[Inter,-apple-system,BlinkMacSystemFont,sans-serif] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-gray-300 border-t-gray-800 rounded-full animate-spin"></div>
          <p className="text-gray-700 text-sm">Loading profile...</p>
        </div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="min-h-screen bg-[#F9F7F4] font-[Inter,-apple-system,BlinkMacSystemFont,sans-serif] flex items-center justify-center">
        <p className="text-gray-700 text-lg">No profile found</p>
      </div>
    );
  }

  return (
    <>
      <Header />

      <div className="relative max-w-full min-h-screen bg-gray-50 font-[Inter,-apple-system,BlinkMacSystemFont,sans-serif]">
        {/* Top profile background section */}
        <div
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="w-full max-w-[1024px] pt-5 pb-0 mx-auto mt-0 flex flex-col relative px-3 md:px-0">
            {/* Cover Photo */}
            <div className="w-full h-[180px] md:h-[220px] lg:h-[250px] mb-[-85px] sm:mb-[-95px] lg:mb-[-105px] rounded-xl overflow-hidden relative">
              <img
                src={profile.cover_image || AdminImg}
                alt="User profile"
                className="w-full h-full object-cover object-center"
              />
            </div>

            {/* Main white section */}
            <div className="w-full max-w-[1024px] px-0 pb-0 mx-auto mt-0 flex flex-col relative rounded-[10px_10px_0px_0px]">
              {/* Profile Picture */}
              <div className="flex relative pl-4 sm:pl-6 w-full max-w-fit mb-[-55px] sm:mb-[-65px] z-10">
                <div className="relative">
                  {profile?.profile_picture ? (
                    <img
                      src={profile.profile_picture}
                      alt="Profile"
                      className="w-[100px] h-[100px] sm:w-[120px] sm:h-[120px] md:w-[130px] md:h-[130px] rounded-full object-cover border-4 border-white shadow-lg"
                    />
                  ) : (
                    <div className="w-[100px] h-[100px] sm:w-[120px] sm:h-[120px] md:w-[130px] md:h-[130px] rounded-full bg-[#e8f0f7] border-4 border-white shadow-lg flex items-center justify-center">
                      <svg
                        className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 text-[#0f6abf]"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>
                    </div>
                  )}
                  <div className="absolute -bottom-0 -right-1 w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 border-white bg-green-500" />
                </div>
              </div>

              {/* Content */}
              <div className="flex flex-col w-full p-3 sm:p-4 pl-4 sm:pl-7 gap-3 sm:gap-4 rounded-t-[10px] bg-white text-gray-900">
                <div className="pl-[110px] sm:pl-[135px] md:pl-[150px]">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between w-full mb-3 gap-3 sm:gap-0">
                    <div className="w-full">
                      <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
                        {profile.name}
                      </h2>

                      {profile.research_areas && (
                        <div className="flex items-center gap-2 sm:gap-3 mt-2">
                          <div className="flex flex-wrap gap-1 sm:gap-2">
                            {profile.research_areas
                              .split(",")
                              .slice(0, 3)
                              .map((area, index) => (
                                <span
                                  key={index}
                                  className="text-[10px] xs:text-xs px-2 py-0.5 sm:px-3 sm:py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-md sm:rounded-lg font-medium"
                                >
                                  {area.trim()}
                                </span>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Blue details card */}
                <div className="w-full flex justify-center">
                  <div className="bg-[#dfefff] rounded-xl sm:rounded-2xl p-4 sm:p-5 lg:p-6 w-full space-y-3 sm:space-y-4">
                    {profile.degree && (
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                        <p className="text-sm sm:text-base font-semibold text-[#0f6abf]">
                          {profile.degree}
                        </p>
                      </div>
                    )}

                    {profile.primary_affiliation && (
                      <div className="pt-2 sm:pt-3 border-t border-gray-200">
                        <div className="flex items-center gap-2 mb-1 sm:mb-2">
                          <svg
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gray-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                            />
                          </svg>
                          <p className="text-xs sm:text-sm font-medium text-gray-900">
                            {profile.primary_affiliation}
                          </p>
                        </div>
                      </div>
                    )}

                    {profile.current_activity && (
                      <div className="flex items-start gap-2">
                        <svg
                          className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gray-500 mt-0.5 flex-shrink-0"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <p className="text-xs sm:text-sm text-gray-700 leading-relaxed">
                          {profile.current_activity}
                        </p>
                      </div>
                    )}

                    {profile.bio && (
                      <div className="w-full pt-3 sm:pt-4 mt-3 sm:mt-4 border-t border-gray-200">
                        <div className="flex items-center gap-2 mb-2 sm:mb-3">
                          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                          <h4 className="text-xs sm:text-sm font-semibold text-gray-900">
                            About
                          </h4>
                        </div>
                        <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                          {profile.bio}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

              </div>

            </div>

          </div>

        </div>

                {/* Complete Your Researcher Profile section OUTSIDE background */}
                <div className="w-full max-w-[1024px] mx-auto px-3 md:px-0 mt-6">
                  <div className="bg-white rounded-t-2xl p-4 sm:p-5 border border-gray-200">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                        <svg
                          className="w-5 h-5 text-[#0f6abf]"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                          />
                        </svg>
                      </div>

                      <div>
                        <h1 className="text-lg font-semibold text-gray-900">
                          Complete Your Researcher Profile
                        </h1>
                        <p className="text-sm text-gray-500">
                          Fill necessary information to become a researcher
                        </p>
                      </div>
                    </div>

                    <p className="text-sm text-gray-600 mb-4">
                      Completing these details will help people understand your
                      expertise and find you easily.
                    </p>
                  </div>
                </div>

                {/* Questions section OUTSIDE background */}
                <div className="w-full max-w-[1024px] mx-auto bg-white rounded-b-xl border-t border-gray-100 p-4 sm:p-6">
                  <ResearchQuestions />
                </div>
              </div>
    </>
  );
};

export default IndependentResearcherLayout;